import _default from './Embed';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/modules/Embed/index.js
// module id = 883
// module chunks = 0